var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.462 0 0 3.571v13.572h4.385V20h2.923l2.923-2.857h3.654l5.115-5V0H1.462Zm15.346 11.429-2.923 2.857H9.5l-2.923 2.857v-2.857H2.923V2.143h13.885v9.286Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.423 4.955h2.192v5.76h-2.192v-5.76Zm-5.115 0H9.5v5.76H7.308v-5.76Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitch.3d60dfcdab5cab0db7dbbb1bf5849672.svg";